<!-- add College popup -->
<div class="addcollege-popup modalpopup-wrap common-popup-ui" *ngIf="this.flag" data-bs-backdrop="static"
  data-bs-keyboard="false" tabindex="-1" aria-labelledby="addCollegePopupLabel" aria-hidden="true">
  <div class="modal-header">
    <h5 class="modal-title">Pending Students List
    </h5>
    <button type="button" class="btn-close" #addModal aria-label="Close" (click)="modalService.dismiss()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="12" fill="#F85D5D" />
        <path
          d="M16.4978 8.32578C16.3954 8.22255 16.2736 8.14062 16.1394 8.0847C16.0051 8.02879 15.8612 8 15.7158 8C15.5704 8 15.4265 8.02879 15.2922 8.0847C15.158 8.14062 15.0362 8.22255 14.9338 8.32578L12.4118 10.8589L9.88969 8.32578C9.6823 8.11839 9.40102 8.00188 9.10773 8.00188C8.81444 8.00188 8.53316 8.11839 8.32578 8.32578C8.11839 8.53316 8.00188 8.81444 8.00188 9.10773C8.00188 9.40102 8.11839 9.6823 8.32578 9.88969L10.8589 12.4118L8.32578 14.9338C8.22255 15.0362 8.14062 15.158 8.0847 15.2922C8.02879 15.4265 8 15.5704 8 15.7158C8 15.8612 8.02879 16.0051 8.0847 16.1394C8.14062 16.2736 8.22255 16.3954 8.32578 16.4978C8.42816 16.601 8.54997 16.6829 8.68418 16.7388C8.81839 16.7947 8.96234 16.8235 9.10773 16.8235C9.25312 16.8235 9.39707 16.7947 9.53128 16.7388C9.66549 16.6829 9.7873 16.601 9.88969 16.4978L12.4118 13.9647L14.9338 16.4978C15.0362 16.601 15.158 16.6829 15.2922 16.7388C15.4265 16.7947 15.5704 16.8235 15.7158 16.8235C15.8612 16.8235 16.0051 16.7947 16.1394 16.7388C16.2736 16.6829 16.3954 16.601 16.4978 16.4978C16.601 16.3954 16.6829 16.2736 16.7388 16.1394C16.7947 16.0051 16.8235 15.8612 16.8235 15.7158C16.8235 15.5704 16.7947 15.4265 16.7388 15.2922C16.6829 15.158 16.601 15.0362 16.4978 14.9338L13.9647 12.4118L16.4978 9.88969C16.601 9.7873 16.6829 9.66549 16.7388 9.53128C16.7947 9.39707 16.8235 9.25312 16.8235 9.10773C16.8235 8.96234 16.7947 8.81839 16.7388 8.68418C16.6829 8.54997 16.601 8.42816 16.4978 8.32578Z"
          fill="#F4F4F4" />
      </svg>
    </button>
  </div>
  <div class="modal-body m-0">
    <div class="row align-items-center justify-content-between mb-3">
      <div class="col-xl-3 col-lg-4 col-12">
        <div class="modal-title1 mb-2 mb-lg-0">
          {{testName}}
        </div>
      </div>
      <div class="col-xl-9 col-lg-8 col-12">
        <div class="d-flex align-items-center justify-content-md-end justify-content-start searchbar-top gap-2 p-0">
          <div class="input-group searchfieldgroup m-0">
            <input type="text" class="form-control" placeholder="Search...." [(ngModel)]="enterSearch"
              aria-label="Search" aria-describedby="search-addon" (keyup)="search($event)"
              oninput="this.value = this.value.replace(/^\s+/g, '')" />
            <span class="input-group-text border-0" id="search-addon">
              <i class="fas fa-search"></i>
            </span>
            <span type="button" class="input-group-append" (click)="cancelSearch()" *ngIf="searchClose">
              <i class="fas fa-times"></i>
            </span>
          </div>
          <button type="button" *ngIf="exportButton" class="btn btn-primary common-button m-0"
            (click)="ExportPendingStudent()"><img src="../../../../assets/img/downloadicon.svg" alt="logo"
              class="img-fluid pe-2"><span>{{TestConstant.Export}}</span></button>
          <button type="button" class="btn btn-primary common-button m-0 icon-btn" (click)="RefreshGrid()"><i
              class="fa-solid fa-rotate-right"></i></button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="table-responsive">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort
            (matSortChange)="SortChange($event)" aria-describedby="list">
            <!--Student Name Column -->
            <ng-container matColumnDef="rowNumber">
              <th mat-header-cell *matHeaderCellDef>{{CommonConstant.SR}} </th>
              <td mat-cell *matCellDef="let element"> {{element.rowNumber}} </td>
            </ng-container>
            <!--Student Name Column -->
            <ng-container matColumnDef="Student Name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="StudentName"> {{TestConstant.NameOfStudent}} </th>
              <td mat-cell *matCellDef="let element"> {{element.studentName}} </td>
            </ng-container>
            <!--Collage Name Column -->
            <ng-container matColumnDef="Collage Name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="CollegeName"> {{TestConstant.College}} </th>
              <td mat-cell *matCellDef="let element" title="{{element.collegeName}}" class="wrapper"> <span
                  class="paraWrap"> {{element.collegeName}} </span> </td>
            </ng-container>
            <!--Email Address Column -->
            <ng-container matColumnDef="Email Address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="EmailId">{{TestConstant.EmailId}} </th>
              <td mat-cell *matCellDef="let element"> {{element.emailId}} </td>
            </ng-container>
            <!-- Phone Number Column -->
            <ng-container matColumnDef="Phone Number">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="MobileNo">{{TestConstant.PhoneNumber}} </th>
              <td mat-cell *matCellDef="let element"> {{element.mobileNo}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div *ngIf="showData" [ngClass]="dataSource.data.length > 0 ? 'hidden' : 'visible'">
            <h5 class="text-center no-data-available py-4">{{NoRecordFound.NoPendingStudentRecordFound}}</h5>
          </div>
        </div>
        <div class="mat-custom-table">
          <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" showFirstLastButtons
            [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>